import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import HomePage from "../pages/home/page";
import Resources from "../pages/resources/page";
import CyberInsuranceChecklist from "../pages/cyber-insurance-checklist/page";
import Partners from "../pages/partners/page";
import Contact from "../pages/contact/page";
import NotFound from "../pages/NotFound";

const HomePageLazy = lazy(() => import("../pages/home/page"));
const PartnersPageLazy = lazy(() => import("../pages/partners/page"));
const ResourcesPageLazy = lazy(() => import("../pages/resources/page"));
const CyberInsuranceChecklistPageLazy = lazy(() => import("../pages/cyber-insurance-checklist/page"));
const ContactPageLazy = lazy(() => import("../pages/contact/page"));
const NotFoundPageLazy = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/cyber-insurance-checklist",
    element: <CyberInsuranceChecklist />,
  },
  {
    path: "/partners",
    element: <Partners />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
